
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/winter",
      function () {
        return require("private-next-pages/winter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/winter"])
      });
    }
  